import React from 'react';

export const ErrorMessage = ({body}) => {
    return (
        <div className="error-message-container">
            <span className="error-message"><i class="fa fa-times-circle"></i> {body}</span>
        </div>
    )
}